import { Yup } from 'shared/lib'

const validSmsCode = /\b\d{6}\b/

export const smsVerificationSchema = Yup.object().shape({
   phoneNumber: Yup.string().required(),
   smsCode: Yup.string().required().matches(validSmsCode, { message: 'validation.smsCode', excludeEmptyString: true }),
})
